/** Cliente HTTP del Análisis de consumo. Espejo de AnalisisConsumoResponse. */
import { apiRequest } from "../../lib/api";

export interface BalanceHidricoMes {
  anio: number;
  mes: number;
  label: string;
  producido_m3: number;
  facturado_m3: number;
  anf_m3: number;
  anf_pct: number | null;
}

export interface BalanceHidrico {
  meses: BalanceHidricoMes[];
  anf_pct_actual: number | null;
  tiene_datos_produccion: boolean;
}

export interface SectorConsumo {
  sector_id: number;
  sector_nombre: string;
  m3: number;
  monto: number;
  n_contratos: number;
  consumo_promedio: number;
  pct_del_total: number;
}

export interface BucketDistribucion {
  label: string;
  desde: number;
  hasta: number | null;
  n_socios: number;
}

export interface TopConsumidor {
  socio_id: number;
  socio_nombre: string;
  sector_nombre: string | null;
  consumo_m3: number;
}

export interface DistribucionSocios {
  buckets: BucketDistribucion[];
  top: TopConsumidor[];
  promedio_m3: number;
  mediana_m3: number;
  total_lecturas: number;
}

export interface AnalisisConsumoResponse {
  periodo: string;
  anio: number;
  mes: number;
  balance_hidrico: BalanceHidrico;
  sectores: SectorConsumo[];
  distribucion: DistribucionSocios;
}

export function fetchAnalisisConsumo(
  anio: number,
  mes: number,
): Promise<AnalisisConsumoResponse> {
  return apiRequest<AnalisisConsumoResponse>(
    `/api/v1/dashboard/analisis-consumo?anio=${anio}&mes=${mes}`,
  );
}
